export default {
    "B1-CAWTC-M1-3.gif": require('../src/assets/images/B1-CAWTC-M1-3.gif'),
    "B1-CAWTC-M1-4.gif": require('../src/assets/images/B1-CAWTC-M1-4.gif'),
    "B1-CAWTC-M1-5.gif": require('../src/assets/images/B1-CAWTC-M1-5.gif'),
    "B1-CAWTC-M1-6.gif": require('../src/assets/images/B1-CAWTC-M1-6.gif'),
    "B1-CAWTC-M1-7.gif": require('../src/assets/images/B1-CAWTC-M1-7.gif'),
    "B1-CAWTC-M1-9.png": require('../src/assets/images/B1-CAWTC-M1-9.png'),
    "B1-CAWTC-M1-10.png": require('../src/assets/images/B1-CAWTC-M1-10.png'),
    "B1-CAWTC-M1-11.png": require('../src/assets/images/B1-CAWTC-M1-11.png'),
    "B1-CAWTC-M1-12.png": require('../src/assets/images/B1-CAWTC-M1-12.png'),
    "B1-CAWTC-M1-13.png": require('../src/assets/images/B1-CAWTC-M1-13.png'),
    "B1-CAWTC-M1-15.png": require('../src/assets/images/B1-CAWTC-M1-15.png'),
    "B1-CAWTC-M1-15.png": require('../src/assets/images/B1-CAWTC-M1-15.png'),
    "B1-CAWTC-M1-15.png": require('../src/assets/images/B1-CAWTC-M1-15.png'),
    "B1-CAWTC-M1-15.png": require('../src/assets/images/B1-CAWTC-M1-15.png'),
    "B1-CAWTC-M1-20.png": require('../src/assets/images/B1-CAWTC-M1-20.png'),
    "B1-CAWTC-M1-20.png": require('../src/assets/images/B1-CAWTC-M1-20.png'),
    "B1-CAWTC-M1-20.png": require('../src/assets/images/B1-CAWTC-M1-20.png'),
    "B1-CAWTC-M1-20.png": require('../src/assets/images/B1-CAWTC-M1-20.png'),
    "B1-CAWTC-M1-20.png": require('../src/assets/images/B1-CAWTC-M1-20.png'),
   "B1-CAWTC-Bravo.png": require('../src/assets/images/B1-CAWTC-Bravo.png'),

    "B1-CAWTC-M2-2.png": require('../src/assets/images/B1-CAWTC-M2-2.png'),
    "B1-CAWTC-M2-3.png": require('../src/assets/images/B1-CAWTC-M2-3.png'),
    "B1-CAWTC-M2-4.png": require('../src/assets/images/B1-CAWTC-M2-4.png'),
    "B1-CAWTC-M2-6.png": require('../src/assets/images/B1-CAWTC-M2-6.png'),
    "B1-CAWTC-M2-7.png": require('../src/assets/images/B1-CAWTC-M2-7.png'),
    "B1-CAWTC-M2-8.png": require('../src/assets/images/B1-CAWTC-M2-8.png'),
    "B1-CAWTC-M2-13.png": require('../src/assets/images/B1-CAWTC-M2-13.png'),
    "B1-CAWTC-M2-14.png": require('../src/assets/images/B1-CAWTC-M2-14.png'),
    "B1-CAWTC-M2-16.png": require('../src/assets/images/B1-CAWTC-M2-16.png'),
    "B1-CAWTC-M2-17.png": require('../src/assets/images/B1-CAWTC-M2-17.png'),
    "B1-CAWTC-Bravo.png": require('../src/assets/images/B1-CAWTC-Bravo.png'),

    "B1-CAWTC-M3-2.png": require('../src/assets/images/B1-CAWTC-M3-2.png'),
    "B1-CAWTC-M3-3.png": require('../src/assets/images/B1-CAWTC-M3-3.png'),
    "B1-CAWTC-M3-4.png": require('../src/assets/images/B1-CAWTC-M3-4.png'),
    "B1-CAWTC-M3-5.png": require('../src/assets/images/B1-CAWTC-M3-5.png'),
    "B1-CAWTC-M3-7.png": require('../src/assets/images/B1-CAWTC-M3-7.png'),
    "B1-CAWTC-M3-8.png": require('../src/assets/images/B1-CAWTC-M3-8.png'),
    "B1-CAWTC-M3-9.png": require('../src/assets/images/B1-CAWTC-M3-9.png'),
    "B1-CAWTC-M3-10.png": require('../src/assets/images/B1-CAWTC-M3-10.png'),
    "B1-CAWTC-M3-12.png": require('../src/assets/images/B1-CAWTC-M3-12.png'),
    "B1-CAWTC-M3-13.png": require('../src/assets/images/B1-CAWTC-M3-13.png'),
    "B1-CAWTC-M3-15.png": require('../src/assets/images/B1-CAWTC-M3-15.png'),
    "B1-CAWTC-M3-16.png": require('../src/assets/images/B1-CAWTC-M3-16.png'),
    "B1-CAWTC-M3-20.png": require('../src/assets/images/B1-CAWTC-M3-20.png'),
    "B1-CAWTC-M3-21.png": require('../src/assets/images/B1-CAWTC-M3-21.png'),

    "B1-CAWTC-M7-2.png": require('../src/assets/images/B1-CAWTC-M7-2.png'),
    "B1-CAWTC-M7-3.png": require('../src/assets/images/B1-CAWTC-M7-3.png'),
    "B1-CAWTC-M7-4.png": require('../src/assets/images/B1-CAWTC-M7-4.png'),
    "B1-CAWTC-M7-5.png": require('../src/assets/images/B1-CAWTC-M7-5.png'),
    "B1-CAWTC-M7-7.png": require('../src/assets/images/B1-CAWTC-M7-7.png'),
    "B1-CAWTC-M7-9.png": require('../src/assets/images/B1-CAWTC-M7-9.png'),
    "B1-CAWTC-M7-10.png": require('../src/assets/images/B1-CAWTC-M7-10.png'),
    "B1-CAWTC-M7-11.png": require('../src/assets/images/B1-CAWTC-M7-11.png'),
    "B1-CAWTC-M7-12.png": require('../src/assets/images/B1-CAWTC-M7-12.png'),
    "B1-CAWTC-M7-13.png": require('../src/assets/images/B1-CAWTC-M7-13.png'),
    "B1-CAWTC-M7-15.png": require('../src/assets/images/B1-CAWTC-M7-15.png'),
    "B1-CAWTC-M7-16.png": require('../src/assets/images/B1-CAWTC-M7-16.png'),
    "B1-CAWTC-M7-17.png": require('../src/assets/images/B1-CAWTC-M7-17.png'),

    "B1-CAWTC-A2.png": require('../src/assets/images/B1-CAWTC-A2.png'),
    "B1-CAWTC-A3.png": require('../src/assets/images/B1-CAWTC-A3.png'),
    "B1-CAWTC-A4.png": require('../src/assets/images/B1-CAWTC-A4.png'),
    "B1-CAWTC-A5.png": require('../src/assets/images/B1-CAWTC-A5.png'),
    "B1-CAWTC-A6.png": require('../src/assets/images/B1-CAWTC-A6.png'),
    "B1-CAWTC-A7.png": require('../src/assets/images/B1-CAWTC-A7.png'),
    "B1-CAWTC-A8.png": require('../src/assets/images/B1-CAWTC-A8.png'),
    "B1-CAWTC-A9.png": require('../src/assets/images/B1-CAWTC-A9.png'),
    "B1-CAWTC-A10.png": require('../src/assets/images/B1-CAWTC-A10.png'),
    "B1-CAWTC-A11.png": require('../src/assets/images/B1-CAWTC-A11.png'),
    "B1-CAWTC-A12.png": require('../src/assets/images/B1-CAWTC-A12.png'),
    "B1-CAWTC-A13.png": require('../src/assets/images/B1-CAWTC-A13.png'),
    "B1-CAWTC-A14.png": require('../src/assets/images/B1-CAWTC-A14.png'),
    "B1-CAWTC-A15.png": require('../src/assets/images/B1-CAWTC-A15.png'),
    "B1-CAWTC-A16.png": require('../src/assets/images/B1-CAWTC-A16.png'),
    "B1-CAWTC-A17.png": require('../src/assets/images/B1-CAWTC-A17.png'),
    "B1-CAWTC-A18.png": require('../src/assets/images/B1-CAWTC-A18.png'),
    
    "B1-CAWTC-B2.png": require('../src/assets/images/B1-CAWTC-B2.png'),
    "B1-CAWTC-B3.png": require('../src/assets/images/B1-CAWTC-B3.png'),
    "B1-CAWTC-B4.png": require('../src/assets/images/B1-CAWTC-B4.png'),
    "B1-CAWTC-B5.png": require('../src/assets/images/B1-CAWTC-B5.png'),
    "B1-CAWTC-B6.png": require('../src/assets/images/B1-CAWTC-B6.png'),
    "B1-CAWTC-B7.png": require('../src/assets/images/B1-CAWTC-B7.png'),
    "B1-CAWTC-B8.png": require('../src/assets/images/B1-CAWTC-B8.png'),
    "B1-CAWTC-B9.png": require('../src/assets/images/B1-CAWTC-B9.png'),
    "B1-CAWTC-B10.png": require('../src/assets/images/B1-CAWTC-B10.png'),
    "B1-CAWTC-B11.png": require('../src/assets/images/B1-CAWTC-B11.png'),
    "B1-CAWTC-B12.png": require('../src/assets/images/B1-CAWTC-B12.png'),
    "B1-CAWTC-B13.png": require('../src/assets/images/B1-CAWTC-B13.png'),
    "B1-CAWTC-B14.png": require('../src/assets/images/B1-CAWTC-B14.png'),
    "B1-CAWTC-B15.png": require('../src/assets/images/B1-CAWTC-B15.png'),
    "B1-CAWTC-B16.png": require('../src/assets/images/B1-CAWTC-B16.png'),
    "B1-CAWTC-B17.png": require('../src/assets/images/B1-CAWTC-B17.png'),
    "B1-CAWTC-B18.png": require('../src/assets/images/B1-CAWTC-B18.png'),
    "B1-CAWTC-B19.png": require('../src/assets/images/B1-CAWTC-B19.png'),
    "B1-CAWTC-B20.png": require('../src/assets/images/B1-CAWTC-B20.png'),
    "B1-CAWTC-B21.png": require('../src/assets/images/B1-CAWTC-B21.png'),
    "B1-CAWTC-B22.png": require('../src/assets/images/B1-CAWTC-B22.png'),
    "B1-CAWTC-B23.png": require('../src/assets/images/B1-CAWTC-B23.png'),
    "B1-CAWTC-B24.png": require('../src/assets/images/B1-CAWTC-B24.png'),
    "B1-CAWTC-B25.png": require('../src/assets/images/B1-CAWTC-B25.png'),
    "B1-CAWTC-B26.png": require('../src/assets/images/B1-CAWTC-B26.png'),
    "B1-CAWTC-B27.png": require('../src/assets/images/B1-CAWTC-B27.png'),
    "B1-CAWTC-B28.png": require('../src/assets/images/B1-CAWTC-B28.png'),
    "B1-CAWTC-B29.png": require('../src/assets/images/B1-CAWTC-B29.png'),
    "B1-CAWTC-B30.png": require('../src/assets/images/B1-CAWTC-B30.png'),
}